"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIntersectionObserver = useIntersectionObserver;

var _react = require("react");

require("intersection-observer");

function useIntersectionObserver(_ref) {
  var _ref$rootMargin = _ref.rootMargin,
      rootMargin = _ref$rootMargin === void 0 ? '0px 0px 0px 0px' : _ref$rootMargin,
      _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === void 0 ? 1.0 : _ref$threshold,
      cb = _ref.cb;
  var observer = (0, _react.useRef)();
  var nodeRef = (0, _react.useRef)();
  var setRef = (0, _react.useCallback)(function (node) {
    if (node) {
      nodeRef.current = node;
      observer.current = new IntersectionObserver(cb, {
        root: node,
        rootMargin: rootMargin,
        threshold: threshold
      });
    }
  }, [cb, rootMargin, threshold]);
  (0, _react.useEffect)(function () {
    return function () {
      if (observer.current && nodeRef.current) {
        observer.current.unobserve(nodeRef.current);
      }
    };
  }, []);
  return {
    observer: observer,
    setRef: setRef
  };
}